import { useCallback } from "react";

import { useDispatch } from "react-redux";

import { showErrorToast } from "app/actions/toast_actions";
import { translate } from "app/filters/i18nFilter";

import type { UseCopiedNotificationOptions } from "./useCopiedNotification";
import { useCopiedNotification } from "./useCopiedNotification";

type UseCopyToClipboardReturn = {
    isCopied: boolean;
    onCopy: (text: string, html?: string) => Promise<void>;
};

export const useCopyToClipboard = (notificationOptions?: UseCopiedNotificationOptions): UseCopyToClipboardReturn => {
    const dispatch = useDispatch();
    const { onCopy: onCopyNotification, isCopied } = useCopiedNotification(notificationOptions);

    const onCopy = useCallback(
        async (text: string, html?: string) => {
            try {
                if (html) {
                    await navigator.clipboard.write([
                        new ClipboardItem({
                            "text/html": new Blob([html], { type: "text/html" }),
                            "text/plain": new Blob([text], { type: "text/plain" }),
                        }),
                    ]);
                } else {
                    await navigator.clipboard.writeText(text);
                }

                onCopyNotification();
            } catch {
                dispatch(showErrorToast(translate("copy_to_clipboard_button.toast.failure")));
            }
        },
        [onCopyNotification],
    );

    return {
        isCopied,
        onCopy,
    };
};
